import http from 'hub-http/clients/apiClient';
import getEarlyRequesterResultPromise from 'ContentEditorUI/earlyRequester/getEarlyRequesterResultPromise';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getAppealStateForScopeRpc } from 'ContentEditorUI/__generated__/chirp/com/hubspot/vetting/rpc/AppealStateService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export default class AccountVerificationApi {
  static fetchAccountVerificationStatus() {
    return getEarlyRequesterResultPromise('initial-account-verification-status-fetch', {
      removeRequestOnSuccess: false
    }) || rpcClient.call(getAppealStateForScopeRpc, {
      request: {
        scopeName: 'landingpages-trusted'
      }
    });
  }
}